module.exports = __webpack_public_path__ + "img/verification-human.7829aeac.svg";